import React from 'react';
import withTermsQuery from 'utils/withTermsQuery';

const PagePasvaldibasKontakti = (props) => {
  const PageWithTerms = withTermsQuery(
    'pasvaldibas_kontakti',
    [
      'kontakti_iestades',
    ],
    props.lang,
    [
      'epasts',
      'amats',
      'vards',
      'uzvards',
      'telefons',
      'neviens_kontakts_neatbilst_filtram',
      'saturs',
      'visas_kontaktu_iestades',
      'satur_vardus',
      'izmantojot_mekletaju',
      'kontaktu_iestade'
    ],
    999,
    ['terms.kontakti_iestades.0.term_order', 'menu_order'], // kārtojam pēc term_order -> menu_order
    ['asc', 'asc']
  );

  // history.location.state.searchInput satur meklētājā ievadīto.
  // Šajā gadījumā tam būtu jābūt darbinieka vārdam, ko norādām
  // izmantošanai iekšlapas filtra laukā (darbinieku kontakti).
  const { history: { location } } = props
  const searchInput = location.state || {}

  const filterProps = {}
  if (searchInput) {
    filterProps.initialFilterState = {
      input: searchInput,
    }
  }

  return <PageWithTerms {...props} {...filterProps} />
}

export default PagePasvaldibasKontakti;



// WEBPACK FOOTER //
// ./src/components/PagePasvaldibasKontakti.js